import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { Button } from 'lib/ui/components'
import bannerShape from 'resources/svg/banner-element.svg'
import { useStoreView } from 'hooks/useStoreView'
import { Title } from '../Styled'
import { Banner, BoxContainer, Container, DivImage, PreHeader } from './styled'

export const AccountHeader = () => {
  const { isSofiaAndGrace } = useStoreView()
  const history = useHistory()

  return (
    <>
      <PreHeader />
      <Container>
        <Title mainTitle isSofiaAndGrace={isSofiaAndGrace}>My profile</Title>
        <Banner>
          {isSofiaAndGrace && (
            <DivImage
              style={{
                backgroundImage: `url(${bannerShape})`
              }}
            />
          )}
          <BoxContainer
            isLivbrite={!isSofiaAndGrace}
          >
            <h1><FormattedMessage id='customer.header.text' /></h1>
            <Button
              onClick={() => history.push('/bladder-control')}
            >
              Shop Now
            </Button>
          </BoxContainer>
        </Banner>
      </Container>
    </>
  )
}
